
import * as actionTypes from "../actionTypes";
import * as constants from "../Constatnts";
import { isNullOrUndefined } from "util";
import axios from "axios";
import { getTokenFromState, handleError } from "../CommonFunctions";




export function getExpenses(
  storeID,
  from,
  size,
  option,
  searchParty,
  searchExpenseDateFrom,
  searchExpenseDateTo,
  searchExpenseCategory,
  searchExpenseNumber,
  searchReferenceNumber
) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;

      let apiUrl = "/transaction/expense";

      const params = {
        from: Number(from),
        size: Number(size),
        storeID: storeID,
        option: option,
        searchParty: searchParty,
        searchExpenseDateFrom: searchExpenseDateFrom,
        searchExpenseDateTo: searchExpenseDateTo,
        searchExpenseCategory: searchExpenseCategory,
        searchExpenseNumber: searchExpenseNumber,
        searchReferenceNumber: searchReferenceNumber
      };

      let queryParams = [];

      Object.keys(params).forEach((key) => {
        if (
          Object.prototype.hasOwnProperty.call(params, key) &&
          params[key] !== undefined &&
          params[key] !== null &&
          params[key] !== ""
        ) {
          queryParams.push(
            key + "=" + encodeURIComponent(params[key])
          );
        }
      });

      if (queryParams.length > 0) {
        apiUrl = apiUrl + "?" + queryParams.join("&");
      }

      const response = await axios.get(
        constants.API_URL + apiUrl,
        {
          headers: {
            Authorization: "Bearer " + token
          }
        }
      );

      if (
        response &&
        Object.prototype.hasOwnProperty.call(response, "data")
      ) {
        return response.data;
      }

      return null;
    } catch (error) {
      console.error("Error fetching expense data:", error);

      if (
        error &&
        Object.prototype.hasOwnProperty.call(error, "response") &&
        error.response &&
        Object.prototype.hasOwnProperty.call(error.response, "data")
      ) {
        throw error.response.data;
      }

      throw error;
    }
  };
}


export function saveExpenses(Expense, key) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      let response = {};

       if (!isNullOrUndefined(key) && key.trim() !== "") {
        // Update existing account
        response = await axios.put(
          `${constants.API_URL}/transaction/expense/${key}`,
          Expense,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      } else {
        // Create new account
        response = await axios.post(
          `${constants.API_URL}/transaction/expense`,
          Expense,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      }

      if (response.data.code === "0") {
        if (key) {
          return key;
        } else {
          return response.data.expense.key;
        }
      }

      return null;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}



export function searchParty(RegistrationID, storeID, searchText) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      const response = await axios.get(
        `${constants.API_URL}/transaction/expenseparty?storeID=${storeID}&userRole=${getState().user.user.Role}&searchText=${searchText}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return {
        totalItemsCount: response.data.totalItemsCount,
        searchResult: response.data.searchResult,
      };
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}

export function cancelExpense(CancellationReason, key) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      const response = await axios.put(
        `${constants.API_URL}/transaction/expense/cancel/${key}`,
          { CancellationReason },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    
      if(response.data.code=="0"){
        return true;
      }
      return false;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}


export function getCashFromCounterAmountForCashRegisterClosing(
  cashRegisterID,
  fromDate
) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      const response = await axios.get(
        `${constants.API_URL}/setup/stores/${getState().user.store.key}/cashregisters/${cashRegisterID}/counteramount?fromDate=${fromDate}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    
      if(response.data.code=="0"){
        return response.data.amount;
      }
       return 0;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}
// export function getCashFromCounterAmountForCashRegisterClosing(
//   cashRegisterID,
//   fromDate
// ) {

//   console.log("fromDate-->",fromDate,"cashRegisterID",cashRegisterID)
//   return (dispatch, getState) => {
//     return database
//       .collection("Expenses")
//       .where("CashRegisterID", "==", cashRegisterID)
//       .where("Status", "==", "Paid")
//       .where("ExpenseDateTime", "<=", new Date())
//       .where("ExpenseDateTime", ">=", fromDate)
//       .get()
//       .then((querySnapshot) => {
//         let amount = 0;
//         querySnapshot.forEach((doc) => {
//           amount = amount + Number(doc.data().Amount);
//           console.log("amount", doc.data().Amount);
//         });
//         // console.log('paymentModeAmount',paymentModeAmount)
//         return amount;
//       })
//       .catch((error) => {
//         console.log(
//           "Error getting getCashFromCounterAmountForCashRegisterClosing : ",
//           error
//         );
//       });
//   };
// }





export function getVendorPendingPayments (vendorID, storeIDs)  {
  return async (dispatch, getState) => {
    try {
      const token = getTokenFromState(getState);

      const response = await axios.get(
        `${constants.API_URL}/transaction/expense/pendingtransaction`,
        {
           params: { storeIDs: storeIDs, vendorID: vendorID },
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      return response.data.data || [];
    } catch (error) {
      handleError(error);
    }
  };
};



